import type { App } from 'vue'

/** Input */
import InputDefault from '@/components/ant/input/InputDefault.vue'
import InputNumberDefault from '@/components/ant/input/InputNumberDefault.vue'
import TextareaInput from '@/components/ant/input/TextareaInput.vue'
import PasswordInput from '@/components/ant/input/PasswordInput.vue'
import SearchInput from '@/components/ant/input/SearchInput.vue'
import EmailInput from '@/components/ant/input/EmailInput.vue'
import UrlInput from '@/components/ant/input/UrlInput.vue'
import TelephoneInput from '@/components/ant/input/TelephoneInput.vue'
import CurrencyInput from '@/components/ant/input/CurrencyInput.vue'
import OtpInput from '@/components/ant/input/OtpInput.vue'
import MaskedInput from '@/components/ant/input/MaskedInput.vue'
import FormatMoney from '@/components/ant/input/FormatMoney.vue'
import InputUnderLine from '@/components/ant/input/InputUnderLine.vue'
import IbanInput from '@/components/ant/input/IbanInput.vue'
import BankAccountInput from '@/components/ant/input/BankAccountInput.vue'
import CreditCardInput from '@/components/ant/input/CreditCardInput.vue'
import CccdInput from '@/components/ant/input/CccdInput.vue'
import LicensePlateInput from '@/components/ant/input/LicensePlateInput.vue'
import ContractNumberInput from '@/components/ant/input/ContractNumberInput.vue'
import CouponCodeInput from '@/components/ant/input/CouponCodeInput.vue'

/** Select / Choice */
import Checkbox from '@/components/ant/select/Checkbox.vue'
import CheckboxGroup from '@/components/ant/select/CheckboxGroup.vue'
import Radio from '@/components/ant/select/Radio.vue'
import Switch from '@/components/ant/select/Switch.vue'
import SelectDefault from '@/components/ant/select/SelectDefault.vue'
import MultiSelect from '@/components/ant/select/MultiSelect.vue'
import TreeSelect from '@/components/ant/select/TreeSelect.vue'
import Cascader from '@/components/ant/select/Cascader.vue'
import Segmented from '@/components/ant/select/Segmented.vue'

/** Address */
import AddressInput from '@/components/ant/address/AddressInput.vue'
import ProvinceSelect from '@/components/ant/address/ProvinceSelect.vue'
import DistrictSelect from '@/components/ant/address/DistrictSelect.vue'
import WardSelect from '@/components/ant/address/WardSelect.vue'
import MapPicker from '@/components/ant/address/MapPicker.vue'

/** Product */
import ProductVariantSelector from '@/components/ant/product/ProductVariantSelector.vue'
import QuantitySelector from '@/components/ant/product/QuantitySelector.vue'

/** Button */
import SaveData from '@/components/ant/button/SaveData.vue'
import Primary from '@/components/ant/button/Primary.vue'
import Add from '@/components/ant/button/Add.vue'

/** Other */
import TinyMce from '@/components/editors/TinyMce.vue'
import GalaxyImage from '@/components/galaxy/GalaxyImage.vue'
import PopupFull from '@/components/ant/modal/PopupFull.vue'

export default {
  install(app: App) {
    // Input
    app.component('h-input', InputDefault)
    app.component('h-inputNumber', InputNumberDefault)
    app.component('h-textarea', TextareaInput)
    app.component('h-password', PasswordInput)
    app.component('h-search', SearchInput)
    app.component('h-email', EmailInput)
    app.component('h-url', UrlInput)
    app.component('h-telephone', TelephoneInput)
    app.component('h-currency', CurrencyInput)
    app.component('h-otp', OtpInput)
    app.component('h-masked', MaskedInput)
    app.component('h-formatMoney', FormatMoney)
    app.component('h-inputUnderline', InputUnderLine)
    app.component('h-iban', IbanInput)
    app.component('h-bankAccount', BankAccountInput)
    app.component('h-creditCard', CreditCardInput)
    app.component('h-cccd', CccdInput)
    app.component('h-licensePlate', LicensePlateInput)
    app.component('h-contractNumber', ContractNumberInput)
    app.component('h-coupon', CouponCodeInput)

    // Select / Choice
    app.component('h-checkbox', Checkbox)
    app.component('h-checkboxGroup', CheckboxGroup)
    app.component('h-radio', Radio)
    app.component('h-switch', Switch)
    app.component('h-select', SelectDefault)
    app.component('h-multiSelect', MultiSelect)
    app.component('h-treeSelect', TreeSelect)
    app.component('h-cascader', Cascader)
    app.component('h-segmented', Segmented)

    // Address
    app.component('h-address', AddressInput)
    app.component('h-province', ProvinceSelect)
    app.component('h-district', DistrictSelect)
    app.component('h-ward', WardSelect)
    app.component('h-mapPicker', MapPicker)

    // Product
    app.component('h-variant', ProductVariantSelector)
    app.component('h-quantity', QuantitySelector)

    // Button / other
    app.component('h-tiny', TinyMce)
    app.component('h-button', Primary)
    app.component('h-galaxy', GalaxyImage)
    app.component('h-popupFull', PopupFull)
    app.component('h-add', Add)
    app.component('h-btn-saveData', SaveData)
  }
}
